export default __webpack_public_path__ + "static/Unionaudio2-20f1f668458ab74e7c4b0644b438ad94.png";